import FlagNL from '~assets/images/flag-nl.png'
import FlagEN from '~assets/images/flag-en.png'

export const Languages = ['nl', 'en']

export const LanguageNames = { nl: 'Nederlands', en: 'Engels' }
export const LanguageFlags = { nl: FlagNL, en: FlagEN }
